
import React, { useEffect } from 'react';
import { AgendaStreamingContext } from '../../../common/AgendaStreamingContextProvider';
import AgendaStreamingSport from './AgendaStreamingSport';
import Loader from '../../../common/Loader';
import MessageInfo from '../../../common/MessageInfo';
import { useFetchAgendaLiveStreaming } from '../../../data/fetchAgendaLiveStreaming';
import { getLabel } from '../../../InitData';
import { getConfiguration } from '../../../data/utils';
import AgendaStreamingTemplateV1 from './templates/AgendaStreamingTemplateV1';

function AgendaStreamingTemplateDefault(props) {
    const agendaStreamingContext = React.useContext(AgendaStreamingContext);
    const [state, , isSetInterval] = useFetchAgendaLiveStreaming();

    useEffect(function() {
        let firstMatch;
        const hasTournaments =  state.data && Object.values(state.data).find(s => s.hasTournaments);
        hasTournaments && Object.values(state.data).forEach(asSport => {
            Object.values(asSport.tournamentsById).forEach(t => {
                if ((firstMatch || null) === null) {
                    firstMatch =  Object.values(t.matchesById).find(m => !m.strOver);
                }
            });
        });
        agendaStreamingContext.setCurrentMatch(firstMatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[state.data]);

    if ((!isSetInterval && state.isLoading) || state.isError) {
        return <Loader error={state.isError} />;
    }

    function messageInfo() {
        return (
            <>
                <div className="bg-nero bianco titolo-blocco-sport pointer">
                    <span className="d-centro-v maiuscolo">
                        <div className={"img-fluid icona-sport margine-dx-mezzo ico-sport icoSport" + props.sportId}></div>
                        {getLabel('live_page.streams_schedule.live_feed')}
                    </span>
                </div>
                <MessageInfo message={getLabel('live_page.streams_schedule.no_matches')} />
            </>
        ) 
    }

    if (!(state.data) || Object.keys(state.data).length === 0) {
        return (
            <>
                {messageInfo()}
            </>
        );
    }

    const hasTournaments =  Object.values(state.data).find(s => {return s.hasTournaments})
    const agendaStreamingSports = hasTournaments && Object.values(state.data).map(function(asSport) {
        return asSport.hasTournaments &&  <AgendaStreamingSport key={asSport.sportId} {...asSport} />;
    });
    
	return (
        <>
            {agendaStreamingSports || 
                messageInfo()
            }
        </>
    );
}

function AgendaStreaming(props) {
    const agendaStreamingContext = React.useContext(AgendaStreamingContext);

    return (agendaStreamingContext.agendaStreamingTemplate == 'V1' ? 
        <AgendaStreamingTemplateV1 />
    :
        <AgendaStreamingTemplateDefault />
    )
}

export default AgendaStreaming;